import React, { useEffect, useState } from 'react';
import Header from '../adminComponents/header/Header';
import MoreHorizIcon from '@mui/icons-material/MoreHoriz';
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import AddIcon from "@mui/icons-material/Add";
import { Card, CardContent, Typography, IconButton, Grid, Box, Button, Menu, MenuItem } from "@mui/material";
import HomeCarosalModal from '../adminComponents/homecarosal/HomeCarosalModal';
import DeleteModal from '../adminComponents/deleteModal/DeleteModal';
import { useMediaQueries } from '../usecontext/UseProvider';
import { getHomeCarousal, deleteHomeCarousal } from '../services/HomeCarousal';

const HomeCarosal = () => {
    const [anchorEl, setAnchorEl] = useState(null);
    const [selectedItem, setSelectedItem] = useState(null);
    const open = Boolean(anchorEl);
    const [openModal, setOpenModal] = useState(false);
    const [deleteOpen, setDeleteOpen] = useState(false);
    const { setLoading } = useMediaQueries();
    const [homeCarousalData, setHomeCarousalData] = useState([]);

    const getHomeCarousalData = async () => {
        try {
            setLoading(true);
            const response = await getHomeCarousal();
            setHomeCarousalData(response.homeCarousal);
        } catch (error) {
            console.error(error);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        getHomeCarousalData();
    }, []);

    const handleClick = (event, item) => {
        setAnchorEl(event.currentTarget);
        setSelectedItem(item);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    const handleOnEdit = () => {
        setOpenModal(true);
        handleClose();
    };

    const handleOnDelete = () => {
        setDeleteOpen(true);
        handleClose();
    };

    const handleDeleteConfirm = async () => {
        try {
            setLoading(true);
            await deleteHomeCarousal(selectedItem._id);
            await getHomeCarousalData();
            setDeleteOpen(false);
        } catch (error) {
            console.error(error);
        } finally {
            setLoading(false);
        }
    };

    const handleModalClose = () => {
        setOpenModal(false);
        setSelectedItem(null);
    };

    return (
        <>
            <Header title="Home Carousel" />
            <Box sx={{ pt: 3 }}>
                <Box textAlign={'end'} mb={2}>
                    <Button
                        onClick={() => {
                            setSelectedItem(null);
                            setOpenModal(true);
                        }}
                        variant="contained"
                        startIcon={<AddIcon sx={{ border: '2px dashed #FFFFFF', borderRadius: '50px', p: 0.5 }} />}
                        sx={{ bgcolor: "#01A0E2", color: "white", borderRadius: '30px' }}>
                        Add New Home Carousel
                    </Button>
                </Box>

                <Grid container spacing={3}>
                    {homeCarousalData?.map((item, index) => (
                        <Grid item xs={12} sm={6} key={index}>
                            <Card sx={{ position: "relative", overflow: "hidden", borderRadius: 2 }}>
                                {/* Background Image */}
                                <Box
                                    component="img"
                                    src={item?.image?.url}
                                    alt={item.title}
                                    sx={{
                                        width: "100%",
                                        height: "250px",
                                        objectFit: "cover",
                                        filter: "brightness(50%)",
                                    }}
                                />
                                {/* Overlay Text */}
                                <CardContent
                                    sx={{
                                        position: "absolute",
                                        top: 0,
                                        left: 0,
                                        right: 0,
                                        bottom: 0,
                                        display: "flex",
                                        flexDirection: "column",
                                        justifyContent: "center",
                                        color: "white",
                                        textAlign: "center",
                                    }}
                                >
                                    <Typography variant="h6" fontWeight="bold" sx={{ color: '#fff' }}>
                                        {item?.title}
                                    </Typography>
                                    <Typography variant="body2" mt={1} sx={{ color: '#fff' }}>
                                        {item?.content}
                                    </Typography>
                                </CardContent>

                                {/* Action Menu */}
                                <Box sx={{ position: "absolute", top: 10, right: 10 }}>
                                    <IconButton
                                        sx={{ bgcolor: "rgba(255, 255, 255, 0.8)" }}
                                        size="small"
                                        onClick={(e) => handleClick(e, item)}
                                    >
                                        <MoreHorizIcon />
                                    </IconButton>
                                </Box>
                            </Card>
                        </Grid>
                    ))}
                </Grid>
            </Box>

            <Menu
                anchorEl={anchorEl}
                open={open}
                onClose={handleClose}
                anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
                transformOrigin={{ vertical: "top", horizontal: "right" }}
                sx={{ borderRadius: '10px' }}
            >
                <MenuItem onClick={handleOnEdit} sx={{ color: '#5B93FF' }}>
                    <EditIcon fontSize="small" sx={{ mr: 1 }} /> Edit
                </MenuItem>
                <MenuItem onClick={handleOnDelete} sx={{ color: '#E71D36' }}>
                    <DeleteIcon fontSize="small" sx={{ mr: 1, color: "error.main" }} /> Delete
                </MenuItem>
            </Menu>

            <HomeCarosalModal 
                open={openModal} 
                setOpen={handleModalClose} 
                homeCarosalData={selectedItem}
                onSuccess={getHomeCarousalData}
            />

            <DeleteModal
                open={deleteOpen}
                handleDeleteClose={() => setDeleteOpen(false)}
                message="Are you sure you want to delete this Home Carousel?"
                handleOnClick={handleDeleteConfirm}
            />
        </>
    );
};

export default HomeCarosal;
